var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBwSmileOkay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mood-empty 1",
    clipPath: "url(#clip0_3205_31964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 20C5.5 21.9698 5.88799 23.9204 6.64181 25.7403C7.39563 27.5601 8.50052 29.2137 9.8934 30.6066C11.2863 31.9995 12.9399 33.1044 14.7597 33.8582C16.5796 34.612 18.5302 35 20.5 35C22.4698 35 24.4204 34.612 26.2403 33.8582C28.0601 33.1044 29.7137 31.9995 31.1066 30.6066C32.4995 29.2137 33.6044 27.5601 34.3582 25.7403C35.112 23.9204 35.5 21.9698 35.5 20C35.5 18.0302 35.112 16.0796 34.3582 14.2597C33.6044 12.4399 32.4995 10.7863 31.1066 9.3934C29.7137 8.00052 28.0601 6.89563 26.2403 6.14181C24.4204 5.38799 22.4698 5 20.5 5C18.5302 5 16.5796 5.38799 14.7597 6.14181C12.9399 6.89563 11.2863 8.00052 9.8934 9.3934C8.50052 10.7863 7.39563 12.4399 6.64181 14.2597C5.88799 16.0796 5.5 18.0302 5.5 20Z",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5 16.6666H15.5167",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.5 16.6666H25.5167",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.5 25H25.5",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3205_31964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwSmileOkay);
export default __webpack_public_path__ + "static/media/bw-smile-okay.d7f6bcd9ba1fafc04e70ef3def3d0053.svg";
export { ForwardRef as ReactComponent };